import { env } from './env';
import { isOndemandOrg, resolveOrgFromHostname } from './org';

const COOKIE_NAME = 'finder_be_endpoint';

function readCookie(name: string): string {
  if (typeof document === 'undefined') return '';
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.slice(name.length + 1)).trim() : '';
}

/** Ondemand BE host mirrors enrollment-fe: `{org}.api.demand.schoolmint.com`. */
export function resolveOndemandBeEndpoint(hostname: string): string {
  const org = resolveOrgFromHostname(hostname);
  return `https://${org}.api.demand.schoolmint.com`;
}

// Dev override: a `finder_be_endpoint` cookie (with protocol) lets the SPA
// target a remote enrollment-be. Ondemand org slugs use the per-org ondemand
// API host; otherwise falls back to the build-time env value.
export function resolveBeEndpoint(
  hostname: string = typeof window !== 'undefined' ? window.location.hostname : '',
): string {
  const override = readCookie(COOKIE_NAME);
  if (/^https?:\/\//i.test(override)) return override;

  if (hostname && isOndemandOrg(hostname)) {
    return resolveOndemandBeEndpoint(hostname);
  }

  return env.apiBaseUrl;
}
